// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-es-404-js": function componentSrcPagesEs404Js() {
    return import("./../../src/pages/es/404.js"
    /* webpackChunkName: "component---src-pages-es-404-js" */
    );
  },
  "component---src-pages-es-index-js": function componentSrcPagesEsIndexJs() {
    return import("./../../src/pages/es/index.js"
    /* webpackChunkName: "component---src-pages-es-index-js" */
    );
  },
  "component---src-pages-fr-404-js": function componentSrcPagesFr404Js() {
    return import("./../../src/pages/fr/404.js"
    /* webpackChunkName: "component---src-pages-fr-404-js" */
    );
  },
  "component---src-pages-fr-index-js": function componentSrcPagesFrIndexJs() {
    return import("./../../src/pages/fr/index.js"
    /* webpackChunkName: "component---src-pages-fr-index-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-pt-pt-404-js": function componentSrcPagesPtPt404Js() {
    return import("./../../src/pages/pt-pt/404.js"
    /* webpackChunkName: "component---src-pages-pt-pt-404-js" */
    );
  },
  "component---src-pages-pt-pt-index-js": function componentSrcPagesPtPtIndexJs() {
    return import("./../../src/pages/pt-pt/index.js"
    /* webpackChunkName: "component---src-pages-pt-pt-index-js" */
    );
  },
  "component---src-pages-ru-404-js": function componentSrcPagesRu404Js() {
    return import("./../../src/pages/ru/404.js"
    /* webpackChunkName: "component---src-pages-ru-404-js" */
    );
  },
  "component---src-pages-ru-index-js": function componentSrcPagesRuIndexJs() {
    return import("./../../src/pages/ru/index.js"
    /* webpackChunkName: "component---src-pages-ru-index-js" */
    );
  },
  "component---src-pages-zh-hans-404-js": function componentSrcPagesZhHans404Js() {
    return import("./../../src/pages/zh-hans/404.js"
    /* webpackChunkName: "component---src-pages-zh-hans-404-js" */
    );
  },
  "component---src-pages-zh-hans-index-js": function componentSrcPagesZhHansIndexJs() {
    return import("./../../src/pages/zh-hans/index.js"
    /* webpackChunkName: "component---src-pages-zh-hans-index-js" */
    );
  },
  "component---src-templates-article-js": function componentSrcTemplatesArticleJs() {
    return import("./../../src/templates/article.js"
    /* webpackChunkName: "component---src-templates-article-js" */
    );
  }
};